export class GoogleWorkspaceGroupMessageMailboxTarget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "address",
            "baseName": "address",
            "type": "string",
            "format": ""
        },
        {
            "name": "label",
            "baseName": "label",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceGroupMessageMailboxTarget.attributeTypeMap;
    }
    constructor() {
    }
}
